  import React from 'react'
import HeroSection from '../HeroSection/HeroSection'
import TransformationProgram from '../TransformationProgram/TransformationProgram'
import HowItWorks from '../HeroSection/HowItWorks/HowItWorks'
import ImageCarousel from '../ImageCarousel/ImageCarousel'
import ImageCarouselT from '../ImageCarousel/ImageCarouselT'
import ProfilePage from '../profile/ProfilePage'
import Facts from '../Fact/Facts'
import FAQ from '../FAQItem/FAQItem'
import LogoMarqueeSection from '../LogoMarqueeSection/LogoMarqueeSection'
import AppreciationPage from '../AppreciationPage/AppreciationPage'
import Footer from '../Footer/Footer'
import ButtonPage from '../ButtonPage/ButtonPage'
import Testimonial from '../Testimonials/testimonials'
import WhyChooseUs from '../WhyChooseUs/WhyChooseUs'
import { Helmet } from 'react-helmet'




const Home = () => {
  return (
    
    <div> 
      <Helmet>
              {/* Facebook Pixel Script */}
              <script type="text/javascript">
                {`
                 !function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '699539346078860');
fbq('track', 'PageView');

                `}
              </script>
              {/* Facebook Pixel NoScript Fallback */}
              <noscript>
                {`
                 <img height="1" width="1" style="display:none"
src="https://www.facebook.com/tr?id=699539346078860&ev=PageView&noscript=1"
/>
                `}
              </noscript>
              <title>Coach Nachiket</title> {/* Updated page title */}
            </Helmet>

        <HeroSection/>
        <ProfilePage/>
        {/* <LogoMarqueeSection/> */}
        {/* <AppreciationPage/> */}
        <ImageCarousel/>
        {/* <TransformationProgram/> */}
        <WhyChooseUs/>
        <Testimonial/>
        <ImageCarouselT/>

        
        {/* <Facts/> */}
        <FAQ/>
         
        <Footer/>
    </div>
  )
}

export default Home